import {priority} from '@priority-software/priority-proto-api/lib';
import {isRTL} from '../../../../../../Localization';
import {formatDate} from '../../../../utils/date';

const dir = isRTL() ? 'rtl' : 'ltr';
const alignment = isRTL() ? 'right' : 'left';
const htmlDirectionAttributes = `dir="${dir}" style="direction:  ${dir}; text-align: ${alignment};"`;

export const prepareSignature = (data: priority.netitems.form.IHtmlSignatureBase | null) => {
    if (!data) return '';

    const {email, sincerely, name, hr, position, phone, cellphone, company, branch} = data;

    const dateObj = new Date();
    const formatType = priority.netitems.form.ColumnType;
    const dateRow = formatDate(dateObj, formatType.Date14);

    let str = `<p ${htmlDirectionAttributes}>${dateRow}</p><p></p>`;

    if (sincerely) {
        str = str.concat(`<p ${htmlDirectionAttributes}>${sincerely}</p>`);
    }

    str = str.concat(`<p ${htmlDirectionAttributes}>${name}</p>`);

    if (position) {
        str = str.concat(`<p ${htmlDirectionAttributes}>${position}</p>`);
    }

    if (company) {
        str = str.concat(`<p ${htmlDirectionAttributes}>${company}</p>`);
    }

    str = str.concat('<p></p>');

    if (branch) {
        str = str.concat(`<p ${htmlDirectionAttributes}>${branch}</p>`);
    }

    if (email) {
        str = str.concat(`<p ${htmlDirectionAttributes}>${email}</p>`);
    }

    if (phone) {
        str = str.concat(`<p ${htmlDirectionAttributes}>${phone}</p>`);
    }

    if (cellphone) {
        str = str.concat(`<p ${htmlDirectionAttributes}>${cellphone}</p>`);
    }

    if (hr) str = str.concat(`<p ${htmlDirectionAttributes}></p><hr/>`);

    return str;
};
